import React from "react";
import { FormControl, InputLabel, Select, MenuItem, Box } from "@mui/material";

interface AllottedStatusFilterProps {
  value: string;
  onChange: (value: string) => void;
}

const AllottedStatusFilter: React.FC<AllottedStatusFilterProps> = ({
  value,
  onChange,
}) => {
  return (
    <Box sx={{ minWidth: 150 }}>
      <FormControl fullWidth size="small">
        <InputLabel>Allotted Status</InputLabel>
        <Select
          value={value}
          label="Allotted Status"
          onChange={(e) => onChange(e.target.value)}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="ALLOTED">Allotted</MenuItem>
          <MenuItem value="NOT_ALLOTED">Not Allotted</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default AllottedStatusFilter;
